import { render, staticRenderFns } from "./maxwebCopy.vue?vue&type=template&id=02151824&scoped=true"
import script from "./maxwebCopy.vue?vue&type=script&lang=js"
export * from "./maxwebCopy.vue?vue&type=script&lang=js"
import style0 from "./maxwebCopy.vue?vue&type=style&index=0&id=02151824&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02151824",
  null
  
)

export default component.exports